import { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import { normalizeUrl } from '../../../../helpers/admin/adminHelper';

import {
    Card, CardMedia, IconButton, ImageList, CardActions,
    CardContent, Collapse, InputAdornment, Link,
    FormControl, InputLabel, Input, useMediaQuery
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { styled } from '@mui/material/styles';

import { GOOGLE_DRIVE_CDN } from '../../../../constants/constants';

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
    })
}));

const BannerImageList = ({ banner, setBanner, deletedImages, setDeletedImages }) => {
    const { type } = banner;
    const matches = useMediaQuery('(max-width: 768.5px)');

    const [images, setImages] = useState([]);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        setImages(banner[type].images);
    }, [banner]);
    
    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(images);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        
        setBanner(e => ({
            ...e,
            [type]: {
                ...e[type],
                images: items
            },
            backup: {
                ...e.backup,
                [type]: items
            }
        }));
    };

    // mostrar más info de banner
    const handleExpandClick = imgId => () => {
        setBanner(e => ({
            ...e,
            [type]: {
                ...e[type],
                images: e[type].images.map(i => (i.imgId === imgId) ? { ...i, expanded: !i.expanded } : i)
            }
        }));
    };

    // cambiar tipo de enlace
    const handleExternalClick = imgId => () => {
        setBanner(e => ({
            ...e,
            [type]: {
                ...e[type],
                images: e[type].images.map(i => (i.imgId === imgId) ? { ...i, external: !i.external } : i)
            }
        }));
    };

    const handleInputChange = imgId => ({ target: { value } }) => {
        setBanner(e => ({
            ...e,
            [type]: {
                ...e[type],
                images: e[type].images.map(i => (i.imgId === imgId) ? { ...i, url: value } : i)
            }
        }));
    };

    // remueve imágenes guardadas de banner
    const removeImg = imgId => () => {
        setBanner(e => ({
            ...e,
            [type]: {
                ...e[type],
                images: e[type].images.filter(i => i.imgId !== imgId)
            }
        }));
        setDeletedImages({
            ...deletedImages,
            [type]: [...deletedImages[type], imgId]
        });
    };

    return (
        <DragDropContext onDragEnd={ handleOnDragEnd }>
            <Droppable droppableId="desktop">
                {(provided) => (
                    <ImageList gap={20} cols={matches ? 2 : 3}
                        {...provided.droppableProps} ref={provided.innerRef}>
                        {
                            images.length > 0 &&
                            images.map(({ imgId, url, expanded, external }, index) => {
                                return (
                                    <Draggable key={imgId} draggableId={imgId} index={index}>
                                        {(provided) => (
                                            <Card key={index} variant="elevation" ref={provided.innerRef}
                                                {...provided.draggableProps} {...provided.dragHandleProps} sx={{ mb: 1 }}>
                                                <CardMedia
                                                    component="img"
                                                    alt={ 'banner-nefropolis' }
                                                    height="140"
                                                    image={ `${GOOGLE_DRIVE_CDN}${imgId} `}
                                                />
                                                <CardActions>
                                                    <IconButton
                                                        onClick={ removeImg(imgId) }
                                                    >
                                                        <RemoveCircleIcon />
                                                    </IconButton>
                                                    <ExpandMore
                                                        expand={ expanded }
                                                        onClick={ handleExpandClick(imgId) }
                                                        aria-expanded={ expanded }
                                                        aria-label="show more"
                                                    >
                                                        <ExpandMoreIcon />
                                                    </ExpandMore>
                                                </CardActions>
                                                <Collapse in={ expanded } timeout="auto" unmountOnExit>
                                                    <CardContent>
                                                        <FormControl fullWidth variant="standard">
                                                            <InputLabel htmlFor="standard-adornment-banner">
                                                                { `URL (${external ? 'externo' : 'local'})` }
                                                            </InputLabel>
                                                            <Input
                                                                id="standard-adornment-banner"
                                                                size="small"
                                                                value={url}
                                                                startAdornment={
                                                                    !external &&
                                                                        <InputAdornment position="start">
                                                                            nefropolis.com
                                                                        </InputAdornment>
                                                                }
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label={
                                                                                external ? 'external url' : 'local url'
                                                                            }
                                                                            onClick={handleExternalClick}
                                                                            onMouseDown={handleMouseDownPassword}
                                                                            onMouseUp={handleMouseUpPassword}
                                                                        >
                                                                            {external ? <LinkOffIcon /> : <LinkIcon />}
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                                onChange={ handleInputChange(imgId) }
                                                            />
                                                        </FormControl>
                                                        <Link href={
                                                            normalizeUrl(`${!external ? `nefropolis.com${url}` : url}`)
                                                        }
                                                            target="_blank" rel="noopener noreferrer">
                                                            Visitar enlace
                                                        </Link>
                                                    </CardContent>
                                                </Collapse>
                                            </Card>
                                        )}
                                    </Draggable>
                                );
                            })
                        }
                        {provided.placeholder}
                    </ImageList>
                )}
            </Droppable>
        </DragDropContext>
    );
};

export default BannerImageList;